angular.module('webremote.dashboard').controller('widget_sessionLinkPro',
  function ($scope, $timeout, $filter, webRtcService, objectManagerService) {
    $scope.om = objectManagerService
    $scope.webRtcServiceOperator = null
    $scope.webRtcServiceOperatorEvent = null
    $scope.mediaElement = undefined
    $scope.mediaElementOperatorEvent = undefined

    $scope.eventLocalLevels = []
    $scope.eventRemoteLevels = []
    $scope.operatorLocalLevels = []
    $scope.operatorRemoteLevels = []

    $scope.initDone = false

    // Workaround to fix render issue for slider
    $timeout(function () {
      $scope.$broadcast('rzSliderForceRender')
    })

    $scope.$watch('activeDashboard', function () {
      $scope.om.object($scope.activeDashboard, 'dashboard').then((v) => {
        $scope.dashboard = v
      })
    })

    $scope.om.object($scope.activeDashboard, 'dashboard').then((dashboard) => {
      $scope.dashboard = dashboard

      // Watch until widgetIndex is set
      $scope.$watch('widgetIndex', async () => {
        try {
          $scope.storedOptions = $scope.dashboard.getInformationForWidget($scope.widgetIndex)

          if ($scope.storedOptions.eventName === undefined) {
            $scope.storedOptions.eventName = 'EventA'
          }

          $scope.webRtcServiceOperator = webRtcService.getInstance('SLP_' + $scope.storedOptions.eventName)
          $scope.webRtcServiceOperatorEvent = webRtcService.getInstance('SLP_' + $scope.storedOptions.eventName + '_Event')

          // Load all streams once
          const streams = await $scope.om.collection('stream')
          // Wait for streamGroup object to be ready
          await $scope.om.collection('streamGroup')

          // If no event source stream selected yet -> choose one
          if ($scope.storedOptions.selectedEventSourceStream === undefined) {
            for (const stream of streams.values()) {
              if (stream.member.elements.at(-1).type.sink !== undefined &&
                  stream.member.elements.at(-1).type.sink.type.jack &&
                  await $scope.belongsToEventWithSearchString(stream, 'Event-Stream')) {
                $scope.storeSelectedEventSourceStream(stream)
                break
              }
            }
          }

          // If no comment stream selected yet -> choose one
          if ($scope.storedOptions.selectedCommentStream === undefined) {
            for (const stream of streams.values()) {
              if (stream.member.elements[0].type.source.type.webRtc &&
                  stream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro &&
                  await $scope.belongsToEvent(stream)) {
                $scope.storeSelectedCommentStream(stream)
                break
              }
            }
          }

          if ($scope.storedOptions.commentatorOptions === undefined) {
            $scope.storedOptions.commentatorOptions = {}
          }

          // If no operator stream selected yet -> choose one
          if ($scope.storedOptions.selectedOperatorSendStream === undefined) {
            for (const stream of streams.values()) {
              if (stream.member.elements.at(-1).type.sink !== undefined &&
                  stream.member.elements.at(-1).type.sink.type.webRtc &&
                  'slave' in stream.member.elements.at(-1).type.sink.type.webRtc.config.method &&
                  await $scope.belongsToEventWithSearchString(stream, 'Operator')) {
                if (stream !== undefined && stream.member.uuid.length > 0) {
                  $scope.selOperatorSendStream = stream
                  $scope.storedOptions.selectedOperatorSendStream = stream.member.uuid
                }
                break
              }
            }
          }
          if ($scope.storedOptions.selectedOperatorReceiveStream === undefined) {
            for (const stream of streams.values()) {
              if (stream.member.elements[0].type.source !== undefined &&
                  stream.member.elements[0].type.source.type.webRtc &&
                  'local' in stream.member.elements[0].type.source.type.webRtc.config.method &&
                  await $scope.belongsToEventWithSearchString(stream, 'Operator')) {
                if (stream !== undefined && stream.member.uuid.length > 0) {
                  $scope.selOperatorReceiveStream = stream
                  $scope.storedOptions.selectedOperatorReceiveStream = stream.member.uuid
                }
                break
              }
            }
          }

          // If no event stream selected yet -> choose one
          if ($scope.storedOptions.selectedEventStream === undefined) {
            for (const stream of streams.values()) {
              if (stream.member.elements.at(-1).type.sink !== undefined &&
                  stream.member.elements.at(-1).type.sink.type.webRtc &&
                  'local' in stream.member.elements.at(-1).type.sink.type.webRtc.config.method &&
                  await $scope.belongsToEventWithSearchString(stream, 'OperatorEvent')) {
                $scope.storeSelectedOperatorEventStream(stream)
                break
              }
            }
          }

          // Get selected event source stream and store it in local object
          $scope.eventSourceStream = await $scope.om.objectSync($scope.storedOptions.selectedEventSourceStream, 'stream')

          // Get selected comment stream and store it in local object
          $scope.selCommentStream = await $scope.om.object($scope.storedOptions.selectedCommentStream, 'stream')

          // Get selected operator streams and store it in local objects
          $scope.selOperatorSendStream = await $scope.om.object($scope.storedOptions.selectedOperatorSendStream, 'stream')
          $scope.selOperatorReceiveStream = await $scope.om.object($scope.storedOptions.selectedOperatorReceiveStream, 'stream')

          // Set operator media element and start if WebRTC stream is already running in background
          $scope.setOperatorMedia()

          // Get selected event stream and store it in local object
          $scope.selEventStream = await $scope.om.object($scope.storedOptions.selectedOperatorEventStream, 'stream')

          // Set event media element and start if WebRTC stream is already running in background
          $scope.setEventMedia()

          if ($scope.storedOptions.operatorOptions === undefined) {
            $scope.storedOptions.operatorOptions = {}
          }
          if ($scope.storedOptions.operatorOptions.talkback === undefined) {
            $scope.storedOptions.operatorOptions.talkback = false
            $scope.storedOptions.operatorOptions.talkbackStream = ''
          }
          if ($scope.storedOptions.operatorOptions.eventSourceMute === undefined) {
            $scope.storedOptions.operatorOptions.eventSourceMute = true
          }
          $scope.webRtcServiceOperatorEvent.remoteMute = $scope.storedOptions.operatorOptions.eventSourceMute
          if ($scope.storedOptions.operatorOptions.micMute === undefined) {
            $scope.storedOptions.operatorOptions.micMute = false
            $scope.storedOptions.operatorOptions.headMute = false
            $scope.storedOptions.operatorOptions.micGain = 100
            $scope.storedOptions.operatorOptions.headGain = 100
          }

          // Important: Trigger Angular Digest
          $scope.initDone = true
          $scope.$applyAsync()
        } catch (err) {
          console.error('Error in sessionLinkPro widgetIndex watcher:', err)
        }
      })
    })

    $scope.$watch('storedOptions', (newVal, oldVal) => {
      if ($scope.initDone && newVal !== undefined && $scope.dashboard !== undefined) {
        $scope.dashboard.storeInformationForWidget($scope.widgetIndex, JSON.stringify(newVal))
      }
    }, true)

    $scope.createSessionLink = function (stream) {
      if (stream !== undefined) {
        stream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.newSid = true
        stream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.admitGuest = true
        stream.update()

        if (stream.member.streamGroup && $scope.storedOptions !== undefined) {
          const streamGroup = $scope.om.objectSync(stream.member.streamGroup, 'streamGroup')
          if (streamGroup !== undefined) {
            streamGroup.member.pendingState = 'playing'
            streamGroup.update()
          }
        }
      }
    }

    $scope.stopGroup = function (stream) {
      if (stream !== undefined && stream.member.streamGroup && $scope.storedOptions !== undefined) {
        const streamGroup = $scope.om.objectSync(stream.member.streamGroup, 'streamGroup')
        if (streamGroup !== undefined) {
          streamGroup.member.pendingState = 'inactive'
          streamGroup.update()
        }
      }
    }

    $scope.getCommentatorName = function (stream, index) {
      if (stream !== undefined && stream.member !== undefined && stream.member.uuid !== undefined) {
        if ($scope.storedOptions.selectedCommentStream === stream.member.uuid) {
          $scope.selCommentStream = stream
          if (index !== undefined) {
            stream.pictureIndex = index
          }
        }
        if (stream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro !== undefined &&
            stream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.peerName) {
          return stream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.peerName
        }
        if (stream.member.streamGroup && $scope.storedOptions !== undefined) {
          const streamGroup = $scope.om.objectSync(stream.member.streamGroup, 'streamGroup')
          if (streamGroup !== undefined &&
          streamGroup.member.tags.find(s => s.startsWith('SLP_' + $scope.storedOptions.eventName + '_'))) {
            return streamGroup.member.tags.find(s => s.startsWith('SLP_' + $scope.storedOptions.eventName + '_'))
              .split('SLP_' + $scope.storedOptions.eventName + '_')[1]
              .replace('-', ' ')
          }
        }
      }
      return ''
    }

    $scope.belongsToEventWithSearchString = function (stream, searchString) {
      if (stream !== undefined && stream.member.streamGroup && $scope.storedOptions !== undefined) {
        const streamGroup = $scope.om.objectSync(stream.member.streamGroup, 'streamGroup')
        if (streamGroup !== undefined &&
          streamGroup.member.tags.find(s => s.startsWith('SLP_' + $scope.storedOptions.eventName + '_' + searchString))) {
          return true
        }
      }
      return false
    }

    $scope.belongsToEvent = function (stream) {
      return $scope.belongsToEventWithSearchString(stream, '')
    }

    $scope.isStreaming = function (streamMember) {
      if (!streamMember || !streamMember.elements) return false
      return streamMember.elements.some(function (el) {
        return el.type && el.type.sink && el.type.sink.type && (el.type.sink.type.icecast || el.type.sink.type.hls)
      })
    }

    $scope.storeSelectedEventSourceStream = function (stream) {
      if (stream !== undefined && stream.member.uuid.length > 0) {
        if ($scope.storedOptions.selectedEventSourceStream !== stream.member.uuid) {
          $scope.storedOptions.selectedEventSourceStream = stream.member.uuid
        }
      }
    }

    $scope.storeSelectedCommentStream = function (stream, index) {
      if (stream !== undefined && stream.member.uuid.length > 0) {
        if (index !== undefined) {
          stream.pictureIndex = index
        }
        $scope.selCommentStream = stream
        if ($scope.storedOptions.selectedCommentStream !== stream.member.uuid) {
          $scope.storedOptions.selectedCommentStream = stream.member.uuid
          if ($scope.storedOptions.selectedTargetStreams === undefined) {
            $scope.storedOptions.selectedTargetStreams = {}
          }
          if ($scope.storedOptions.selectedTargetStreams[stream.member.uuid] === undefined) {
            $scope.storedOptions.selectedTargetStreams[stream.member.uuid] = {}
          }
        }
      }
    }

    $scope.storeSelectedOperatorEventStream = function (stream) {
      if (stream !== undefined && stream.member.uuid.length > 0) {
        if ($scope.storedOptions.selectedOperatorEventStream !== stream.member.uuid) {
          $scope.storedOptions.selectedOperatorEventStream = stream.member.uuid
        }
      }
    }

    $scope.addToSelectedTargetStream = function (targetStream) {
      if ($scope.selCommentStream.member.elements.at(-1).type.sink.type.jack) {
        const inputMapping = $scope.selCommentStream.member.elements.at(-1).type.sink.type.jack.mapping
        const targetMapping = targetStream.member.elements[0].type.source.type.jack.mapping
        if (!targetMapping.soundcard) {
          targetMapping.soundcard =
            inputMapping.soundcard
        }
        for (let i = 0; i < inputMapping.mapping.length; i++) {
          if (!targetMapping.mapping.includes(inputMapping.mapping[i] + '_in')) {
            targetMapping.mapping.push(inputMapping.mapping[i] + '_in')
          }
        }
      }
      $scope.adaptMixMatrixTargetStream(targetStream)
      targetStream.update()
    }

    $scope.delFromSelectedTargetStream = function (targetStream) {
      if ($scope.selCommentStream.member.elements.at(-1).type.sink.type.jack) {
        const inputMapping = $scope.selCommentStream.member.elements.at(-1).type.sink.type.jack.mapping
        const targetMapping = targetStream.member.elements[0].type.source.type.jack.mapping
        for (let i = 0; i < inputMapping.mapping.length; i++) {
          targetMapping.mapping = targetMapping.mapping.filter(e => e !== inputMapping.mapping[i] + '_in')
        }
        $scope.adaptMixMatrixTargetStream(targetStream)
        targetStream.update()
      }
    }

    $scope.adaptMixMatrixTargetStream = function (targetStream) {
      // event channels set to 0 if status is not active
      // event channel set to 1 if eventPassthrough set
      // last channel(s) (for commentary) always set to 1 for both output channels if onAir

      const nrInputChannels = targetStream.elements[0].type.source.type.jack.mapping.mapping.length
      const nrEventInputChannels = 2
      const nrOutputChannels = 2
      if ($scope.storedOptions.commentatorOptions[targetStream.member.uuid] === undefined) {
        $scope.storedOptions.commentatorOptions[targetStream.member.uuid] = {}
      }
      if ($scope.storedOptions.commentatorOptions[targetStream.member.uuid].eventPassthrough === undefined) {
        $scope.storedOptions.commentatorOptions[targetStream.member.uuid].eventPassthrough = false
      }
      const eventChannelLoudness = $scope.storedOptions.commentatorOptions[targetStream.member.uuid].eventPassthrough ? 1 : 0
      if (targetStream.member.elements[1].type.processing.type.mixMatrix !== undefined) {
        targetStream.member.elements[1].type.processing.type.mixMatrix.mode.custom.nrRows = nrOutputChannels

        const data = Array(nrInputChannels * nrOutputChannels).fill(0)
        // Event Stream input stereo pass through ToDo (with damping)
        data[0] = eventChannelLoudness
        data[nrInputChannels + 1] = eventChannelLoudness
        if (nrInputChannels > nrEventInputChannels) {
          for (let i = nrEventInputChannels; i < nrInputChannels; i++) {
            let channelLoudness = 1
            if ($scope.storedOptions.operatorOptions.talkback &&
                $scope.storedOptions.operatorOptions.talkbackStream === $scope.selCommentStream.member.uuid &&
                  targetStream.member.elements[0].type.source.type.jack.mapping.mapping[i] ===
                    $scope.selCommentStream.member.elements.at(-1).type.sink.type.jack.mapping.mapping[0] + '_in') {
              channelLoudness = 0
            }

            // Check for onAir in connected comment stream and set channel loudness to 0 otherwise
            for (const commentStreamUuid in $scope.storedOptions.selectedTargetStreams) {
              for (const targetStreamUuid in $scope.storedOptions.selectedTargetStreams[commentStreamUuid]) {
                if (targetStreamUuid === targetStream.member.uuid && $scope.storedOptions.selectedTargetStreams[commentStreamUuid][targetStreamUuid]) {
                  const commentStream = $scope.om.objectSync(commentStreamUuid, 'stream')
                  if (targetStream.member.elements[0].type.source.type.jack.mapping.mapping[i] ===
                      commentStream.member.elements.at(-1).type.sink.type.jack.mapping.mapping[0] + '_in' &&
                      commentStream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.statusText !== 'OnAir') {
                    channelLoudness = 0
                  }
                }
              }
            }

            // Set the channel loudness for the commentary channels
            for (let j = 0; j < nrOutputChannels; j++) {
              data[j * nrInputChannels + i] = channelLoudness
            }
          }
        }
        targetStream.member.elements[1].type.processing.type.mixMatrix.mode.custom.data = data
      }
    }

    $scope.toogleOnAir = function (commentStream) {
      if (commentStream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.statusText === 'OnAir') {
        commentStream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.statusText = 'Online'
        commentStream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.statusColor = 'Grey'
      } else {
        commentStream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.statusText = 'OnAir'
        commentStream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.statusColor = '#c04040'
      }
      commentStream.update()

      // update target streams to reflect if commentator is On Air
      for (const targetStream of $filter('orderBy')($filter('filter')($filter('filter')($scope.om.collectionSync('stream'), $scope.belongsToEvent), $scope.isStreaming), 'member.name')) {
        $scope.adaptMixMatrixTargetStream(targetStream)
        targetStream.update()
      }
    }

    $scope.toogleEventPassthrough = function (targetStream) {
      if ($scope.storedOptions.commentatorOptions[targetStream.member.uuid] === undefined) {
        $scope.storedOptions.commentatorOptions[targetStream.member.uuid] = {}
      }
      if ($scope.storedOptions.commentatorOptions[targetStream.member.uuid].eventPassthrough !== undefined) {
        $scope.storedOptions.commentatorOptions[targetStream.member.uuid].eventPassthrough = !$scope.storedOptions.commentatorOptions[targetStream.member.uuid].eventPassthrough
      } else {
        $scope.storedOptions.commentatorOptions[targetStream.member.uuid].eventPassthrough = true
      }

      $scope.adaptMixMatrixTargetStream(targetStream)
      targetStream.update()
    }

    $scope.toogleTalkback = async function () {
      $scope.storedOptions.operatorOptions.talkback = !$scope.storedOptions.operatorOptions.talkback
      $scope.storedOptions.operatorOptions.talkbackStream = $scope.selCommentStream.member.uuid

      // Turn on talkback
      if ($scope.storedOptions.operatorOptions.talkback) {
        // Link commentator output to operator input
        if ($scope.selCommentStream.member.elements.at(-1).type.sink.type.jack) {
          const inputMapping = $scope.selCommentStream.member.elements.at(-1).type.sink.type.jack.mapping
          const targetMapping = $scope.selOperatorSendStream.member.elements[0].type.source.type.jack.mapping
          if (!targetMapping.soundcard) {
            targetMapping.soundcard =
            inputMapping.soundcard
          }
          for (let i = 0; i < inputMapping.mapping.length; i++) {
            if (!targetMapping.mapping.includes(inputMapping.mapping[i] + '_in')) {
              targetMapping.mapping = [inputMapping.mapping[i] + '_in']
            }
          }
        }
        $scope.selOperatorSendStream.update()
        // Link operator output to commentator input
        // First get commentator send stream
        const commentStreamGroup = await $scope.om.objectSync($scope.selCommentStream.member.streamGroup, 'streamGroup')
        const selCommentSendStream = await $scope.om.objectSync(commentStreamGroup.member.streams.find(stream => stream !== $scope.selCommentStream.member.uuid), 'stream')

        if ($scope.selOperatorReceiveStream.member.elements.at(-1).type.sink.type.jack) {
          const inputMapping = $scope.selOperatorReceiveStream.member.elements.at(-1).type.sink.type.jack.mapping
          const targetMapping = selCommentSendStream.member.elements[0].type.source.type.jack.mapping
          if (!targetMapping.soundcard) {
            targetMapping.soundcard =
            inputMapping.soundcard
          }
          for (let i = 0; i < inputMapping.mapping.length; i++) {
            if (!targetMapping.mapping.includes(inputMapping.mapping[i] + '_in')) {
              targetMapping.mapping = [inputMapping.mapping[i] + '_in', inputMapping.mapping[i] + '_in']
            }
          }
        }
        selCommentSendStream.update()
      } else {
        // Turn off talkback
        // Link virtual silence output on operator input
        const targetMapping = $scope.selOperatorSendStream.member.elements[0].type.source.type.jack.mapping
        targetMapping.mapping = ['virt_2a2147c2-21b5-4a69-a0f0-38f0eb21d112_in']
        $scope.selOperatorSendStream.update()

        // Link event output to commentator input
        // First get commentator send stream
        const commentStreamGroup = await $scope.om.objectSync($scope.selCommentStream.member.streamGroup, 'streamGroup')
        const selCommentSendStream = await $scope.om.objectSync(commentStreamGroup.member.streams.find(stream => stream !== $scope.selCommentStream.member.uuid), 'stream')

        // Second get event source stream
        if ($scope.eventSourceStream.member !== undefined && $scope.eventSourceStream.member.elements.at(-1).type.sink.type.jack) {
          const inputMapping = $scope.eventSourceStream.member.elements.at(-1).type.sink.type.jack.mapping
          const targetMapping = selCommentSendStream.member.elements[0].type.source.type.jack.mapping
          if (!targetMapping.soundcard) {
            targetMapping.soundcard =
            inputMapping.soundcard
          }
          targetMapping.mapping = []
          for (let i = 0; i < inputMapping.mapping.length; i++) {
            if (!targetMapping.mapping.includes(inputMapping.mapping[i] + '_in')) {
              targetMapping.mapping = [inputMapping.mapping[i] + '_in', inputMapping.mapping[i] + '_in']
            }
          }
        }
        selCommentSendStream.update()
      }

      for (const targetStream of $filter('orderBy')($filter('filter')($filter('filter')($scope.om.collectionSync('stream'), $scope.belongsToEvent), $scope.isStreaming), 'member.name')) {
        $scope.adaptMixMatrixTargetStream(targetStream)
        targetStream.update()
      }
    }

    // Operator WebRTC stream
    $scope.setOperatorMedia = async function () {
      $scope.mediaElement = document.getElementById('operator_media')
      if ($scope.webRtcServiceOperator.remoteStream) {
        $scope.createOperatorWebRtcSession()
      }
    }

    $scope.startstopOperatorWebRtcSession = function () {
      if ($scope.webRtcServiceOperator.connectionState === '') {
        $scope.createOperatorWebRtcSession()
      } else {
        $scope.webRtcServiceOperator.stop()
      }
    }

    $scope.createOperatorWebRtcSession = async function () {
      $scope.webRtcServiceOperator.webRtcGroup = $scope.selOperatorSendStream.member.streamGroup
      // Update callback for Angular scope updates
      const updateCallback = (audioLevels) => {
        $scope.operatorLocalLevels = [...audioLevels.local]
        $scope.operatorRemoteLevels = [...audioLevels.remote]
        $scope.$apply()
      }

      await $scope.webRtcServiceOperator.startConnection('operator_media', webRtcService.MediaMode.BIDIRECTIONAL, webRtcService.MediaMode.RECEIVE_ONLY, updateCallback)
      // Auto play, if ready
      $scope.mediaElement.addEventListener('loadeddata', () => {
        if ($scope.mediaElement.readyState >= 3) {
          $scope.mediaElement.play()
        }
      })
    }

    // Event WebRTC stream
    $scope.setEventMedia = async function () {
      $scope.mediaElementOperatorEvent = document.getElementById('operator_event_media')
      if ($scope.webRtcServiceOperatorEvent.remoteStream) {
        $scope.createEventWebRtcSession()
      }
    }

    $scope.startstopOperatorEventWebRtcSession = function () {
      if ($scope.webRtcServiceOperatorEvent.connectionState === '') {
        $scope.createEventWebRtcSession()
      } else {
        $scope.webRtcServiceOperatorEvent.stop()
      }
    }

    $scope.createEventWebRtcSession = async function () {
      $scope.webRtcServiceOperatorEvent.webRtcGroup = $scope.selEventStream.member.streamGroup

      // Update callback for Angular scope updates
      const updateCallback = (audioLevels) => {
        $scope.eventLocalLevels = [...audioLevels.local]
        $scope.eventRemoteLevels = [...audioLevels.remote]
        $scope.$apply()
      }

      await $scope.webRtcServiceOperatorEvent.startConnection('operator_event_media', webRtcService.MediaMode.RECEIVE_ONLY, webRtcService.MediaMode.RECEIVE_ONLY, updateCallback)
      // $scope.isActive = true
      // $scope.status = 'Active'
      // $scope.audioChannels = $scope.webRtcServiceOperatorEvent.getLocalChannelCount()
      // $scope.sampleRate = $scope.webRtcServiceOperatorEvent.getSampleRate()
      // $scope.$apply()

      // Auto play, if ready
      $scope.mediaElementOperatorEvent.addEventListener('loadeddata', () => {
        if ($scope.mediaElementOperatorEvent.readyState >= 3) {
          $scope.mediaElementOperatorEvent.play()
        }
      })
    }

    $scope.admitCommentator = function (commentStream) {
      commentStream.member.elements[0].type.source.type.webRtc.config.method.sessionLinkPro.admitGuest = true
      commentStream.update()
    }

    $scope.getConnectionState = function (webRtcInstance) {
      if (webRtcInstance) {
        if (webRtcInstance.connectionState === 'connecting') {
          return 'Connecting'
        } else if (webRtcInstance.connectionState === 'connected') {
          return 'Disconnect'
        } else {
          return 'Connect'
        }
      }
    }

    // Chat functions and states
    $scope.draft = ''
    $scope.canSend = function () { return !!($scope.draft && $scope.draft.trim().length) }

    $scope.onKeydown = function (evt) {
      if (evt.key === 'Enter' && !evt.shiftKey) {
        evt.preventDefault()
        $scope.send()
      }
    }

    $scope.send = function () {
      if (!$scope.canSend()) return
      var msg = $scope.draft.trim()
      $scope.draft = ''
      if ($scope.selCommentStream.member.streamGroup) {
        const streamGroup = $scope.om.objectSync($scope.selCommentStream.member.streamGroup, 'streamGroup')
        if (streamGroup !== undefined && streamGroup !== '') {
          for (const streamUuid of streamGroup.member.streams) {
            const stream = $scope.om.objectSync(streamUuid, 'stream')
            if (stream.member.elements.at(-1).type.sink !== undefined &&
            stream.member.elements.at(-1).type.sink.type.webRtc &&
            'slave' in stream.member.elements.at(-1).type.sink.type.webRtc.config.method) {
              stream.member.elements.at(-1).type.sink.type.webRtc.message = msg
              stream.update()
              break
            }
          }
        }
      }
    }

    $scope.clear = function () {
      $scope.selCommentStream.member.elements[0].type.source.type.webRtc.config.chatCache = []
      $scope.selCommentStream.update()
    }

    $scope.$watchCollection(
      'selCommentStream.member.elements[0].type.source.type.webRtc.config.chatCache',
      function () {
        $timeout(function () {
          var body = document.getElementById('chatBody')
          if (body) body.scrollTop = body.scrollHeight
        }, 0)
      }
    )

    $scope.sliderOptionsOperator = {
      disabled: false,
      floor: 0,
      ceil: 100,
      step: 1,
      showSelectionBar: false,
      hideLimitLabels: true,
      vertical: false,
      hidePointerLabels: true,
      onlyBindHandles: true,
      showTicks: 5,
      showTicksValues: 50,
      id: 'operatorSlider',
      onEnd: function () {
        // this.update()
      }
    }

    $scope.copyToClipboard = function (text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text)
      } else {
        // Fallback for HTTP or older browsers
        var textArea = document.createElement('textarea')
        textArea.value = text
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
      }
    }
  }
)
